import { Suspense } from 'react'

import { cn } from '@/lib/utils'

import { CaseAlerts } from '../case-alerts/case-alerts'
import { CheckCaseInformation } from './check-case-information/check-case-information'
import { CheckNvcCaseLoader } from './check-nvc-case-loader'

export const CheckNvcCase = () => {
  return (
    <div className={cn('mb-6', 'px-6')}>
      <h3 className={cn('text-base font-medium')}>Case Detail</h3>
      <div className={cn('mt-[18px]', 'space-y-5')}>
        <Suspense fallback={<CheckNvcCaseLoader />}>
          <CheckCaseInformation />
        </Suspense>
        <CaseAlerts showsLabel />
      </div>
    </div>
  )
}
